import { Component } from '@angular/core';

@Component({
  selector: 'rs-connect-isp',
  templateUrl: 'connect-isp.component.html',
  styleUrls: ['connect-isp.component.scss']
})
export class ConnectISPComponent {}
